package ru.villawonka.app.presentation.sharedviews

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.material.CircularProgressIndicator
import androidx.compose.material.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import ru.villawonka.app.presentation.design.theme.surfaceLow

@Composable
fun DefaultLoadingStateLayout(
    topPadding: Dp = 0.dp,
) {
    Box(
        modifier = Modifier
            .background(MaterialTheme.colors.surfaceLow)
            .fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {
        Spacer(modifier = Modifier.height(topPadding))
        CircularProgressIndicator()
    }
}